export default __webpack_public_path__ + "static/media/logo.6f15300a.png";